import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'tk', name: 'Türkmençe', flag: '🇹🇲' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 md:gap-2 px-2 md:px-3 py-1 md:py-1.5 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
        aria-label="Select language"
      >
        <span className="text-base md:text-lg">{currentLanguage.flag}</span>
        <span className="hidden sm:inline text-xs md:text-sm font-medium text-gray-700">
          {currentLanguage.code.toUpperCase()}
        </span>
        <i className={`ri-arrow-down-s-line text-sm md:text-base text-gray-600 transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 md:w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full flex items-center gap-2 md:gap-3 px-3 md:px-4 py-2 md:py-2.5 hover:bg-gray-50 transition-colors cursor-pointer ${
                currentLanguage.code === lang.code ? 'bg-teal-50 text-teal-600' : 'text-gray-700'
              }`}
            >
              <span className="text-base md:text-lg">{lang.flag}</span>
              <span className="text-xs md:text-sm font-medium">{lang.name}</span>
              {currentLanguage.code === lang.code && (
                <i className="ri-check-line ml-auto text-teal-600 text-sm md:text-base"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}